import { gql } from '@apollo/client';

const query = gql`
  query CategoriesQuery($path: String) {
    categories(path: $path) {
      edges {
        node {
          id
          name
          description
          path
          quotable
          relatedCategories {
            id
            name
            path
          }
        }
      }
    }
  }
`;

module.exports = query;
